import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FaSave, FaCog } from 'react-icons/fa';
import { FiPrinter } from 'react-icons/fi';
import instanciaAxios from '../../miscelaneo/instanciaAxios';
import InputClientes from '../util/Inputs/InputClientes';
import TablaEntidad from '../util/tablas/TablaEntidad';
import PlantillaModal from '../util/PlantillaModal';
import SpinnerCargando from '../util/SpinnerCargando';

// Opciones de formato PDF reutilizables
const OPCIONES_FORMATO = [
  { value: 'carta', label: 'Carta (Letter)' },
  { value: 'continuo', label: 'Continuo (80mm)' }
];

// Tipos de documento con sus claves y etiquetas
const TIPOS_FORMATO_PDF = [
  { key: 'formato_pdf_factura', label: 'Facturas' },
  { key: 'formato_pdf_compra', label: 'Compras a Proveedores' },
  { key: 'formato_pdf_gasto_menor', label: 'Gastos Menores' },
  { key: 'formato_pdf_pago_exterior', label: 'Pagos al Exterior' },
  { key: 'formato_pdf_nota_credito', label: 'Notas de Crédito' },
  { key: 'formato_pdf_nota_debito', label: 'Notas de Débito' },
  { key: 'formato_pdf_recibo_pago', label: 'Recibos de Pago' },
  { key: 'formato_pdf_cotizacion', label: 'Cotizaciones' }
];

const MODOS_IMPRESION_FLEJE = [
  { value: 'zpl', label: 'ZPL — Zebra / 2connet (recomendado)' },
  { value: 'tspl', label: 'TSPL — TSC' },
  { value: 'epl2', label: 'EPL2 — Eltron / Zebra antigua' },
  { value: 'pdf', label: 'PDF (navegador)' },
];

const TAMANOS_FLEJE = [
  { value: '108x30', label: '108 × 30 mm (2connet estándar)' },
  { value: '110x30', label: '110 × 30 mm' },
  { value: '105x30', label: '105 × 30 mm' },
  { value: '90x30', label: '90 × 30 mm' },
  { value: '70x30', label: '70 × 30 mm (~7×3 cm)' },
  { value: '75x25', label: '75 × 25 mm' },
  { value: '60x30', label: '60 × 30 mm' },
];

const TABS = [
  { id: 'facturacion', label: 'Facturación' },
  { id: 'balanza', label: 'Balanza' },
  { id: 'etiquetas', label: 'Etiquetas' },
];

export default function ValoresPorDefecto() {
  // Estados
  const [tabActivo, setTabActivo] = useState('facturacion');
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [configuracion, setConfiguracion] = useState({
    cliente_consumidor_final: null,
    nombre_cliente_consumidor: '',
    id_pasarela_pago_defecto: null,
    nombre_pasarela_defecto: '',
    id_sucursal_defecto: null,
    nombre_sucursal_defecto: '',
    formato_pdf_factura: 'carta',
    formato_pdf_compra: 'carta',
    formato_pdf_gasto_menor: 'carta',
    formato_pdf_pago_exterior: 'carta',
    formato_pdf_nota_credito: 'carta',
    formato_pdf_nota_debito: 'carta',
    formato_pdf_recibo_pago: 'carta',
    formato_pdf_cotizacion: 'continuo',
    mostrar_impuesto_linea_continuo: false,
    mostrar_telefono_factura: false,
    mostrar_balance_pendiente_pago_factura: false,
    mostrar_rnc_factura_demo: false,
    nota_pie_factura: '',
    exportar_linea_pesable: false,
    nombre_archivo_exportacion_pesable: '',
    modo_impresion_fleje: 'zpl',
    tamano_fleje: '70x30',
    impresora_fleje: ''
  });
  const [mostrarModalClientes, setMostrarModalClientes] = useState(false);
  const [pasarelas, setPasarelas] = useState([]);
  const [sucursales, setSucursales] = useState([]);

  // Cargar configuración al montar
  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setCargando(true);
      const [respuesta, pasarelasResp, sucursalesResp] = await Promise.all([
        instanciaAxios.get('/miscelaneo/configuracion'),
        instanciaAxios.get('/pasarela-pago'),
        instanciaAxios.get('/miscelaneo/sucursal').catch(() => ({ data: [] }))
      ]);
      const data = respuesta.data;

      setConfiguracion({
        cliente_consumidor_final: data.id_entidad_cliente_defecto || null,
        nombre_cliente_consumidor: data.nombre_cliente || data.razon_social_cliente || '',
        id_pasarela_pago_defecto: data.id_pasarela_pago_defecto || null,
        nombre_pasarela_defecto: data.nombre_pasarela_defecto || '',
        id_sucursal_defecto: data.id_sucursal_defecto || null,
        nombre_sucursal_defecto: data.nombre_sucursal_defecto || '',
        formato_pdf_factura: data.formato_pdf_factura || 'carta',
        formato_pdf_compra: data.formato_pdf_compra || 'carta',
        formato_pdf_gasto_menor: data.formato_pdf_gasto_menor || 'carta',
        formato_pdf_pago_exterior: data.formato_pdf_pago_exterior || 'carta',
        formato_pdf_nota_credito: data.formato_pdf_nota_credito || 'carta',
        formato_pdf_nota_debito: data.formato_pdf_nota_debito || 'carta',
        formato_pdf_recibo_pago: data.formato_pdf_recibo_pago || 'carta',
        formato_pdf_cotizacion: data.formato_pdf_cotizacion || 'continuo',
        mostrar_impuesto_linea_continuo: data.mostrar_impuesto_linea_continuo ?? false,
        mostrar_telefono_factura: data.mostrar_telefono_factura ?? false,
        mostrar_balance_pendiente_pago_factura: data.mostrar_balance_pendiente_pago_factura ?? false,
        mostrar_rnc_factura_demo: data.mostrar_rnc_factura_demo ?? false,
        nota_pie_factura: data.nota_pie_factura || '',
        exportar_linea_pesable: data.exportar_linea_pesable ?? false,
        nombre_archivo_exportacion_pesable: data.nombre_archivo_exportacion_pesable || '',
        modo_impresion_fleje: data.modo_impresion_fleje || 'zpl',
        tamano_fleje: data.tamano_fleje || '70x30',
        impresora_fleje: data.impresora_fleje || ''
      });
      setPasarelas(pasarelasResp.data || []);
      setSucursales(sucursalesResp.data || []);
    } catch (error) {
      console.error('Error al cargar configuración:', error);
      if (error.response?.status !== 404) {
        toast.error('Error al cargar configuración');
      }
    } finally {
      setCargando(false);
    }
  };

  const handleSeleccionarCliente = (cliente) => {
    setConfiguracion({
      ...configuracion,
      cliente_consumidor_final: cliente.id_entidad,
      nombre_cliente_consumidor: cliente.nombre || cliente.razon_social || ''
    });
    setMostrarModalClientes(false);
  };

  const handleGuardar = async () => {
    try {
      setGuardando(true);
      await instanciaAxios.put('/miscelaneo/configuracion', {
        id_entidad_cliente_defecto: configuracion.cliente_consumidor_final,
        id_pasarela_pago_defecto: configuracion.id_pasarela_pago_defecto,
        id_sucursal_defecto: configuracion.id_sucursal_defecto,
        formato_pdf_factura: configuracion.formato_pdf_factura,
        formato_pdf_compra: configuracion.formato_pdf_compra,
        formato_pdf_gasto_menor: configuracion.formato_pdf_gasto_menor,
        formato_pdf_pago_exterior: configuracion.formato_pdf_pago_exterior,
        formato_pdf_nota_credito: configuracion.formato_pdf_nota_credito,
        formato_pdf_nota_debito: configuracion.formato_pdf_nota_debito,
        formato_pdf_recibo_pago: configuracion.formato_pdf_recibo_pago,
        formato_pdf_cotizacion: configuracion.formato_pdf_cotizacion,
        mostrar_impuesto_linea_continuo: configuracion.mostrar_impuesto_linea_continuo,
        mostrar_telefono_factura: configuracion.mostrar_telefono_factura,
        mostrar_balance_pendiente_pago_factura: configuracion.mostrar_balance_pendiente_pago_factura,
        mostrar_rnc_factura_demo: configuracion.mostrar_rnc_factura_demo,
        nota_pie_factura: configuracion.nota_pie_factura || null,
        exportar_linea_pesable: configuracion.exportar_linea_pesable,
        nombre_archivo_exportacion_pesable: configuracion.nombre_archivo_exportacion_pesable || null,
        modo_impresion_fleje: configuracion.modo_impresion_fleje,
        tamano_fleje: configuracion.tamano_fleje,
        impresora_fleje: configuracion.impresora_fleje || null
      });
      toast.success('Configuración guardada exitosamente');
    } catch (error) {
      console.error('Error al guardar configuración:', error);
      toast.error('Error al guardar configuración');
    } finally {
      setGuardando(false);
    }
  };

  const handleLimpiar = () => {
    setConfiguracion({
      cliente_consumidor_final: null,
      nombre_cliente_consumidor: '',
      id_pasarela_pago_defecto: null,
      nombre_pasarela_defecto: '',
      id_sucursal_defecto: null,
      nombre_sucursal_defecto: '',
      formato_pdf_factura: 'carta',
      formato_pdf_compra: 'carta',
      formato_pdf_gasto_menor: 'carta',
      formato_pdf_pago_exterior: 'carta',
      formato_pdf_nota_credito: 'carta',
      formato_pdf_nota_debito: 'carta',
      formato_pdf_recibo_pago: 'carta',
    formato_pdf_cotizacion: 'continuo',
      mostrar_impuesto_linea_continuo: false,
      mostrar_telefono_factura: false,
      mostrar_balance_pendiente_pago_factura: false,
      mostrar_rnc_factura_demo: false,
      nota_pie_factura: '',
      exportar_linea_pesable: false,
      nombre_archivo_exportacion_pesable: '',
      modo_impresion_fleje: 'zpl',
      tamano_fleje: '70x30',
      impresora_fleje: ''
    });
  };

  if (cargando) {
    return <SpinnerCargando />;
  }

  return (
    <div className="min-h-screen bg-gray-200 py-8 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <div className="flex items-center gap-3 mb-2">
            <FaCog className="text-color-primario text-2xl" />
            <h1 className="font-cascadia text-xl font-semibold text-gray-800">
              Valores por Defecto
            </h1>
          </div>
          <p className="text-sm text-gray-500">
            Configure los valores predeterminados para los módulos del sistema
          </p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm">
          <div className="flex border-b border-gray-200">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setTabActivo(tab.id)}
                className={`px-6 py-3 text-sm font-medium transition-colors border-b-2 -mb-px ${
                  tabActivo === tab.id
                    ? 'border-color-primario text-color-primario'
                    : 'border-transparent text-gray-500 hover:text-gray-700'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="p-6">

            {/* ── Tab: Facturación ── */}
            {tabActivo === 'facturacion' && (
              <div className="space-y-6">
                {/* Cliente Consumidor Final */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Cliente Consumidor Final
                    <span className="text-gray-400 font-normal ml-2">
                      (Cliente que se usará automáticamente en ventas sin cliente específico)
                    </span>
                  </label>
                  <InputClientes
                    valor={configuracion.cliente_consumidor_final}
                    onClick={() => setMostrarModalClientes(true)}
                    placeholder="Seleccionar cliente consumidor final..."
                    nombreCliente={configuracion.nombre_cliente_consumidor}
                    editable={true}
                  />
                  {configuracion.cliente_consumidor_final && (
                    <p className="text-xs text-gray-500 mt-1">
                      Cliente seleccionado: {configuracion.nombre_cliente_consumidor}
                    </p>
                  )}
                </div>

                {/* Pasarela de Pago por Defecto */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Pasarela de Pago por Defecto
                    <span className="text-gray-400 font-normal ml-2">
                      (Se seleccionará automáticamente al elegir pago con tarjeta)
                    </span>
                  </label>
                  <select
                    value={configuracion.id_pasarela_pago_defecto || ''}
                    onChange={(e) => setConfiguracion({
                      ...configuracion,
                      id_pasarela_pago_defecto: e.target.value ? parseInt(e.target.value) : null,
                      nombre_pasarela_defecto: pasarelas.find(p => p.id_pasarela_pago === parseInt(e.target.value))?.nombre || ''
                    })}
                    className="w-full p-2.5 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  >
                    <option value="">Sin pasarela por defecto</option>
                    {pasarelas.map(pasarela => (
                      <option key={pasarela.id_pasarela_pago} value={pasarela.id_pasarela_pago}>
                        {pasarela.nombre}
                      </option>
                    ))}
                  </select>
                  {configuracion.id_pasarela_pago_defecto && (
                    <p className="text-xs text-gray-500 mt-1">
                      Pasarela seleccionada: {configuracion.nombre_pasarela_defecto}
                    </p>
                  )}
                </div>

                {/* Sucursal por Defecto */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Sucursal por Defecto
                    <span className="text-gray-400 font-normal ml-2">
                      (Sucursal que se usará automáticamente en el POS y facturación)
                    </span>
                  </label>
                  <select
                    value={configuracion.id_sucursal_defecto || ''}
                    onChange={(e) => setConfiguracion({
                      ...configuracion,
                      id_sucursal_defecto: e.target.value ? parseInt(e.target.value) : null,
                      nombre_sucursal_defecto: sucursales.find(s => s.id_sucursal === parseInt(e.target.value))?.descripcion || ''
                    })}
                    className="w-full p-2.5 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  >
                    <option value="">Sin sucursal por defecto</option>
                    {sucursales.map(sucursal => (
                      <option key={sucursal.id_sucursal} value={sucursal.id_sucursal}>
                        {sucursal.descripcion}
                      </option>
                    ))}
                  </select>
                  {configuracion.id_sucursal_defecto && (
                    <p className="text-xs text-gray-500 mt-1">
                      Sucursal seleccionada: {configuracion.nombre_sucursal_defecto}
                    </p>
                  )}
                </div>

                {/* Formatos de PDF */}
                <div>
                  <h3 className="text-base font-semibold text-gray-800 mb-3 pt-2 border-t border-gray-100">Formatos de PDF</h3>
                  <p className="text-sm text-gray-500 mb-4">
                    Seleccione el formato de papel por defecto para cada tipo de documento
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {TIPOS_FORMATO_PDF.map(({ key, label }) => (
                      <div key={key} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200">
                        <label className="text-sm font-medium text-gray-700">{label}</label>
                        <select
                          value={configuracion[key] || 'carta'}
                          onChange={(e) => setConfiguracion({ ...configuracion, [key]: e.target.value })}
                          className="ml-4 p-2 rounded-lg border border-gray-300 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none"
                        >
                          {OPCIONES_FORMATO.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </div>
                    ))}
                  </div>

                  <div className="mt-4 flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                    <div>
                      <p className="text-sm font-medium text-gray-800">Mostrar impuesto por línea en formato continuo</p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        Si se activa, se muestra el impuesto por cada línea en impresión continua (PDF y térmica). El total de impuesto siempre se imprime.
                      </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer ml-4 shrink-0">
                      <input
                        type="checkbox"
                        checked={configuracion.mostrar_impuesto_linea_continuo}
                        onChange={(e) => setConfiguracion({ ...configuracion, mostrar_impuesto_linea_continuo: e.target.checked })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-color-primario"></div>
                    </label>
                  </div>

                  <div className="mt-4 flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                    <div>
                      <p className="text-sm font-medium text-gray-800">Mostrar teléfono del emisor en facturas</p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        Si se activa, se imprime el teléfono del tenant debajo de la dirección en facturas (PDF carta, PDF continuo y ticket térmico). Por defecto está desactivado.
                      </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer ml-4 shrink-0">
                      <input
                        type="checkbox"
                        checked={configuracion.mostrar_telefono_factura}
                        onChange={(e) => setConfiguracion({ ...configuracion, mostrar_telefono_factura: e.target.checked })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-color-primario"></div>
                    </label>
                  </div>

                  <div className="mt-4 flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                    <div>
                      <p className="text-sm font-medium text-gray-800">Mostrar balance pendiente de pago en facturas</p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        Si se activa, se imprime la línea "Balance pendiente de pago" cuando el cliente tiene saldo anterior. Por defecto está desactivado.
                      </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer ml-4 shrink-0">
                      <input
                        type="checkbox"
                        checked={configuracion.mostrar_balance_pendiente_pago_factura}
                        onChange={(e) => setConfiguracion({ ...configuracion, mostrar_balance_pendiente_pago_factura: e.target.checked })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-color-primario"></div>
                    </label>
                  </div>

                  <div className="mt-4 flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                    <div>
                      <p className="text-sm font-medium text-gray-800">Mostrar RNC en factura demo</p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        Controla si se imprime el RNC (el de la empresa y el del cliente) en facturas demo (sin comprobante fiscal) en PDF carta, PDF continuo y ticket térmico. Por defecto está desactivado.
                      </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer ml-4 shrink-0">
                      <input
                        type="checkbox"
                        checked={configuracion.mostrar_rnc_factura_demo}
                        onChange={(e) => setConfiguracion({ ...configuracion, mostrar_rnc_factura_demo: e.target.checked })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-color-primario"></div>
                    </label>
                  </div>
                </div>

                {/* Nota al Pie de Factura */}
                <div>
                  <h3 className="text-base font-semibold text-gray-800 mb-1 pt-2 border-t border-gray-100">Nota al Pie de Factura</h3>
                  <p className="text-sm text-gray-500 mb-3">
                    Texto que aparecerá al final de todas las facturas impresas (térmica y PDF)
                  </p>
                  <textarea
                    value={configuracion.nota_pie_factura}
                    onChange={(e) => setConfiguracion({ ...configuracion, nota_pie_factura: e.target.value })}
                    className="w-full p-3 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm"
                    rows="3"
                    maxLength={200}
                    placeholder="Ej: Gracias por su compra. Devoluciones dentro de 7 días con factura."
                  />
                  <p className="text-xs text-gray-400 mt-1 text-right">
                    {configuracion.nota_pie_factura.length}/200 caracteres
                  </p>
                </div>
              </div>
            )}

            {/* ── Tab: Balanza ── */}
            {tabActivo === 'balanza' && (
              <div className="space-y-4">
                <p className="text-sm text-gray-500">
                  Configuración de exportaciones automáticas para productos pesables (balanza)
                </p>
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                  <div>
                    <p className="text-sm font-medium text-gray-800">Exportar línea de producto pesable</p>
                    <p className="text-xs text-gray-500 mt-0.5">
                      Al crear o actualizar un producto pesable, descarga automáticamente un archivo .txt con los datos del producto en formato de integración (balanza)
                    </p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer ml-4 shrink-0">
                    <input
                      type="checkbox"
                      checked={configuracion.exportar_linea_pesable}
                      onChange={(e) => setConfiguracion({ ...configuracion, exportar_linea_pesable: e.target.checked })}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-color-primario"></div>
                  </label>
                </div>

                {configuracion.exportar_linea_pesable && (
                  <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nombre del archivo exportado
                      <span className="text-gray-400 font-normal ml-2">(sin extensión .txt)</span>
                    </label>
                    <input
                      type="text"
                      value={configuracion.nombre_archivo_exportacion_pesable}
                      onChange={(e) => setConfiguracion({ ...configuracion, nombre_archivo_exportacion_pesable: e.target.value })}
                      maxLength={100}
                      placeholder="producto_{codigo}"
                      className="w-full p-2.5 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm font-cascadia"
                    />
                    <p className="text-xs text-gray-400 mt-1">
                      Si se deja vacío, se usará el nombre por defecto: <span className="font-cascadia">producto_&#123;codigo&#125;.txt</span>
                    </p>
                  </div>
                )}
              </div>
            )}

            {/* ── Tab: Etiquetas ── */}
            {tabActivo === 'etiquetas' && (
              <div className="space-y-4">
                <p className="text-sm text-gray-500">
                  Configuración por defecto para impresión de etiquetas de producto. Compatible con 2connet 2C-LP427B y Zebra.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Modo de impresión
                    </label>
                    <select
                      value={configuracion.modo_impresion_fleje}
                      onChange={(e) => setConfiguracion({ ...configuracion, modo_impresion_fleje: e.target.value })}
                      className="w-full p-2.5 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm"
                    >
                      {MODOS_IMPRESION_FLEJE.map(m => (
                        <option key={m.value} value={m.value}>{m.label}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Tamaño de etiqueta
                    </label>
                    <select
                      value={configuracion.tamano_fleje}
                      onChange={(e) => setConfiguracion({ ...configuracion, tamano_fleje: e.target.value })}
                      className="w-full p-2.5 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm"
                    >
                      {TAMANOS_FLEJE.map(t => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Impresora de etiquetas
                    <span className="text-gray-400 font-normal ml-2">(nombre exacto como aparece en QZ Tray)</span>
                  </label>
                  <input
                    type="text"
                    value={configuracion.impresora_fleje}
                    onChange={(e) => setConfiguracion({ ...configuracion, impresora_fleje: e.target.value })}
                    placeholder="Ej: 2connet 2C-LP427B"
                    className="w-full p-2.5 rounded-xl border-2 outline-none transition-all border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 text-sm"
                  />
                  <p className="text-xs text-gray-400 mt-1">
                    Si se deja vacío, se usará la impresora térmica configurada en la caja o la primera disponible en QZ Tray.
                  </p>
                </div>
              </div>
            )}

          </div>
        </div>

        {/* Footer con botones */}
        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={handleLimpiar}
            className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-xl hover:bg-gray-100 transition-colors"
          >
            Limpiar
          </button>
          <button
            onClick={handleGuardar}
            disabled={guardando}
            className="flex items-center gap-2 px-4 py-2 bg-color-primario text-white rounded-xl hover:bg-color-secundario transition-colors disabled:opacity-50"
          >
            <FaSave />
            {guardando ? 'Guardando...' : 'Guardar Configuración'}
          </button>
        </div>
      </div>

      {/* Modal de Selección de Cliente */}
      <PlantillaModal
        mostrar={mostrarModalClientes}
        onClose={() => setMostrarModalClientes(false)}
        titulo="Seleccionar Cliente Consumidor Final"
      >
        <TablaEntidad
          setEntidadSeleccionada={handleSeleccionarCliente}
          descripcion="Seleccione el cliente que se usará para consumidores finales"
        />
      </PlantillaModal>
    </div>
  );
}
